/* @flow */

import axios from 'axios';
import qs from 'qs';
import { API } from './constants';
import headersApi from './headers-api';

const { location }: { location: Location } = global;

const solicitarLogin = (error: any) => {
    if (error.response && error.response.status === 401) {
        const urlSolicitada = encodeURIComponent(location.href);
        location.assign(`${location.origin}/login?url-solicitada=${urlSolicitada}`);
    }
    return Promise.reject(error);
};

const xhr = axios.create({
    baseURL: API,
    paramsSerializer: qs.stringify,
    headers: headersApi(),
});

xhr.interceptors.response.use(r => r, solicitarLogin);

export default xhr;
